import NoData from "assets/svgs/no_data/NoData";
import React from "react";

function DietPlanQa({ dietData }) {
  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}
    >
      {dietData?.dietPlanQuesAndRes?.length ? (
        dietData?.dietPlanQuesAndRes?.map((item) => {
          return (
            <div className="mb-3 card p-2" key={item?.questionId}>
              <div className="fw-bold text-black" style={{fontFamily:"poppins"}}>
                {item.question}
                <span className="ms-1 text-secondary">
                  ({item?.questionId})
                </span>{" "}
              </div>
              <div className="border-bottom my-1"></div>
              <p style={{fontFamily:"poppins"}}>{item.actualResponse?item.actualResponse:item?.response}</p>
            </div>
          );
        })
      ) : (
        <div className="text-center p-2 border">No Data Available <NoData /></div>
      )}
    </div>
  );
}

export default DietPlanQa;
